import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import Loader from "@/components/loader";
import { getPopularCompaniesAPIData } from "@/services/businessDirectory";
import { dnbComLog, LogSeverity } from "@/shared/FunctionCore";

interface Companies {
  name: string;
  revenue: string;
  url: string;
  country?: string;
}

const PopularCompanies = ({ countryCode, languageCode }) => {
  const { t } = useTranslation();
  const [popularCompanies, setPopularCompanies] = useState<Companies[]>([]);
  const [loadingState, setLoadingState] = useState<boolean>(true);

  useEffect(() => {
    const getPopularCompaniesData = async () => {
      try {
        const apiData = await getPopularCompaniesAPIData(
          countryCode,
          languageCode
        );
        if (apiData && apiData.data !== null) {
          setPopularCompanies(apiData.data.businessDirectoryTopCompanies);
          setLoadingState(false);
        }
      } catch (err) {
        dnbComLog(LogSeverity.ERROR, err.message);
        setLoadingState(false);
      }
    };
    getPopularCompaniesData();
  }, [countryCode, languageCode]);

  const renderCompanies = () => (
    <>
      {popularCompanies &&
        popularCompanies.length > 0 ?
        <div className="popularCompaniesGrid">
          {popularCompanies.map((companies, index) => (
            <div className="item" key={index}>
              <div className="companyName">
                <a className="link" href={`${companies.url + '.html'}`}>
                  {companies.name}
                </a>
              </div>
              <span>{companies.revenue}</span>
            </div>
          ))}
        </div> : <div>{t("businessDirectory.noCompaniesFoundMessage")}</div>}
    </>
  )

  return (
    <>
      <div>
        <ToastContainer position="top-center" />
        <div className="popularCompaniesContainer">
          <div className="popularCompaniesWrapper">
            <div className="popularCompanies">
              <div className="popularCompaniesHeading">
                {t("businessDirectory.popularCompaniesLabel")}
              </div>
              {loadingState ? <Loader inProgress={loadingState} /> : renderCompanies()}
            </div>
            <div className="popularCompaniesBackgroundColor" />
          </div>
        </div>
      </div>
    </>
  );
};

export default PopularCompanies;
